import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

function services() {
    return (
        <section id='services' className='services p-0'>
            <div className='container'>
                <div className='heading-sec w-100 g-5 mb-lg-5 mb-4 d-lg-flex flex-row-reverse align-items-center justify-content-between'>
                    <div className='text-right ps-lg-5'>
                        <div className='strip-heading'>Services</div>
                        <h2 className='h3-heading text-dark'>Bridging Innovation  with Modern Tech Solutions</h2>
                    </div>
                    <div className='text-left pe-lg-5'>
                        <p className='fs-5 text-dark fw-400'>We develop cutting-edge solutions and transform existing ones through collaborative development that prioritises your success.</p>
                    </div>
                </div>
                <div className='services-card'>
                    <a href='#' className='h-100 d-flex text-dark text-decoration-none bg-light mb-4 rounded-4'>
                        <div className='left-sec pe-xl-5 pe-3 w-100  d-lg-flex align-items-center'>
                            <h2 className='col-lg-4 col-12 pe-xl-5 pe-3 h4-heading text-dark'><span className='me-xl-5 me-3 d-lg-inline-block d-none font-primary'>1.</span>Stratagy</h2>
                            <p className='col-lg-8  col-12'>Tailored software solutions to meet specific business needs, enhancing efficiency and productivity.</p>
                        </div>
                        <div className='more d-flex align-items-center ps-md-4 ps-3 fw-600'><FontAwesomeIcon className='ms-2' icon={faArrowRight} /></div>
                    </a>
                </div>
                <div className='services-card'>
                    <a href='#' className='h-100 d-flex text-dark text-decoration-none bg-light mb-4 rounded-4'>
                        <div className='left-sec pe-xl-5 pe-3 w-100  d-lg-flex align-items-center'>
                            <h2 className='col-lg-4 col-12 pe-xl-5 pe-3 h4-heading text-dark'><span className='me-xl-5 me-3 d-lg-inline-block d-none font-primary'>2.</span>Development</h2>
                            <p className='col-lg-8  col-12'>Scalable cloud solutions for data storage, backup, and computing power, enabling flexibility and cost-effectiveness.</p>
                        </div>
                        <div className='more d-flex align-items-center ps-md-4 ps-3 fw-600'><FontAwesomeIcon className='ms-2' icon={faArrowRight} /></div>
                    </a>
                </div>
                <div className='services-card'>
                    <a href='#' className='h-100 d-flex text-dark text-decoration-none bg-light mb-4 rounded-4'>
                        <div className='left-sec pe-xl-5 pe-3 w-100  d-lg-flex align-items-center'>
                            <h2 className='col-lg-4 col-12 pe-xl-5 pe-3 h4-heading text-dark'><span className='me-xl-5 me-3 d-lg-inline-block d-none font-primary'>3.</span>Branding</h2>
                            <p className='col-lg-8  col-12'>Comprehensive security measures to protect sensitive data and systems from threats and breaches.</p>
                        </div>
                        <div className='more d-flex align-items-center ps-md-4 ps-3 fw-600'><FontAwesomeIcon className='ms-2' icon={faArrowRight} /></div>
                    </a>
                </div>
                <div className='services-card'>
                    <a href='#' className='h-100 d-flex text-dark text-decoration-none bg-light rounded-4'>
                        <div className='left-sec pe-xl-5 pe-3 w-100  d-lg-flex align-items-center'>
                            <h2 className='col-lg-4 col-12 pe-xl-5 pe-3 h4-heading text-dark'><span className='me-xl-5 me-3 d-lg-inline-block d-none font-primary'>4.</span>Marketing</h2>
                            <p className='col-lg-8  col-12'>Ongoing technical support and system maintenance to ensure optimal performance and minimal downtime.</p>
                        </div>
                        <div className='more d-flex align-items-center ps-md-4 ps-3 fw-600'><FontAwesomeIcon className='ms-2' icon={faArrowRight} /></div>
                    </a>
                </div>
            </div>
        </section>
    )
}

export default services

